module.exports = __webpack_public_path__ + "img/2_31.5a225584.png";